const Data = [
  {
    name: "Dhananjay Sarkar",
    position: "SRC Head",
    imageUrl: "/assets/images/members/Heads26/DhananjaySarkar.jpg",
    facebookLink: "https://www.facebook.com/share/16qrDB6GBG/",
    email: "sarkardhananjay796@gmail.com",
    linkedinLink: "https://www.linkedin.com/in/dhananjay-sarkar-55aa24319?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Mandli Venkata Sai Charith",
    position: "SRC Head",
    imageUrl: "/assets/images/members/Heads26/MandliVenkataSaiCharith.jpg",
    facebookLink: "https://www.facebook.com/share/173XcmTMxG/",
    email: "charithmvs123.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/venkata-sai-charith-mandli-05a142355?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    name: "Om Manoj Akulwar",
    position: "SRC Head",
    imageUrl: "/assets/images/members/Heads26/OmManojAkulwar.jpg",
    facebookLink: "",
    email: "omakulwar05.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/om-akulwar-848991312?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Kumkum Gorai",
    position: "SRC Head",
    imageUrl: "/assets/images/members/Heads26/KumkumGorai.jpeg",
    facebookLink: "",
    email: "kumkumgorai.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/kumkum-gorai-617215364"
  },
  {
    name: "Chetna Kanesh",
    position: "SRC Head",
    imageUrl: "/assets/images/members/Heads26/ChetnaKanesh.jpg",
    facebookLink: "",
    email: "kc277e.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/chetna-kanesh-29219a328?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Sudhanshu Pandey",
    position: "SRC Head",
    imageUrl: "/assets/images/members/Heads26/SudhanshuPandey.jpeg",
    facebookLink: "",
    email: "pandeysudhanshu2024.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/sudhanshu-pandey-50713b310?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  }
];

export default Data;